import React from "react";
import { useTranslation } from "react-i18next";

function VisaServicesPromotion(props) {

    var { t } = useTranslation();

    return (
        <div className="uk-margin-medium-top uk-card uk-card-body uk-background-muted uk-border-rounded">
            <h2 className="uk-heading-small uk-margin-small-bottom">{t("infopages.services.visa.cardTitle")}</h2>

            <p>
                {t("infopages.services.visa.description")}
            </p>

            <ul className="uk-list uk-list-disc uk-margin">
                <li>{t("infopages.services.visa.listItem1")}</li>
                <li>{t("infopages.services.visa.listItem2")}</li>
                <li>{t("infopages.services.visa.listItem3")}</li>
                <li>{t("infopages.services.visa.listItem4")}</li>
            </ul>

            <p className="uk-text-bold uk-margin-remove-top">
                {t("infopages.services.visa.commercialBenefits")}
            </p>

            <a href="/apply-visa" className="uk-button uk-button-jai uk-margin-top">
                {t("infopages.services.visa.applyButton")}
            </a>
        </div>
    );
}

export default VisaServicesPromotion;